var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAisleSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14626_7244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0542 23.7404C13.2009 23.7549 13.3453 23.7771 13.4953 23.7771H24.3973C25.3762 23.7771 26.3029 23.3482 26.9373 22.6015C27.5717 21.8549 27.8439 20.8671 27.6862 19.8927C27.4284 18.306 25.964 17.1104 24.2785 17.1104H15.212L14.3009 13.7771H24.2762V11.5549H13.6942L11.9731 5.25709C11.522 3.53709 9.91763 2.42821 8.23766 2.67487C7.2999 2.81265 6.46214 3.34487 5.94104 4.13376C5.41994 4.92265 5.25772 5.90043 5.50105 6.82376L9.20542 20.4949C9.48431 21.526 10.1232 22.3826 10.9576 22.9649L10.1854 24.5082C9.66541 25.5504 9.71986 26.7615 10.3321 27.7515C10.9443 28.7415 12.0031 29.3326 13.1676 29.3326H26.5006V27.1104H13.1665C12.6076 27.1104 12.3198 26.7415 12.2209 26.5838C12.1231 26.4238 11.922 26.0026 12.172 25.5015L13.0531 23.7393L13.0542 23.7404Z",
    fill: "#F7C740"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14626_7244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6661,
    height: 26.6667,
    fill: "white",
    transform: "translate(3.16663 2.66602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisleSeat);
export default __webpack_public_path__ + "static/media/aisleSeat.b0b47bd401710966d63bee48e5c3768c.svg";
export { ForwardRef as ReactComponent };